import { api } from './apiClient';

export interface FeatureFlagMeta {
  id: string;
  key: string;
  label: string;
  description: string;
  defaultEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface FeatureFlagsResponse {
  registry: FeatureFlagMeta[];
  userFlags: Record<string, boolean>;
}

export const featureFlagsApi = {
  list(): Promise<FeatureFlagsResponse> {
    return api<FeatureFlagsResponse>('/api/feature-flags', { auth: true });
  },

  setUser(key: string, enabled: boolean): Promise<{ userFlags: Record<string, boolean> }> {
    return api<{ userFlags: Record<string, boolean> }>(
      `/api/feature-flags/${encodeURIComponent(key)}`,
      { auth: true, method: 'PUT', body: { enabled } },
    );
  },

  // ---- Admin ----
  adminList(): Promise<{ flags: FeatureFlagMeta[] }> {
    return api<{ flags: FeatureFlagMeta[] }>('/api/admin/feature-flags', { auth: true });
  },

  adminCreate(input: {
    key: string;
    label: string;
    description?: string;
    defaultEnabled?: boolean;
  }): Promise<{ flag: FeatureFlagMeta }> {
    return api<{ flag: FeatureFlagMeta }>('/api/admin/feature-flags', {
      auth: true,
      method: 'POST',
      body: input,
    });
  },

  adminUpdate(
    id: string,
    input: { label?: string; description?: string; defaultEnabled?: boolean },
  ): Promise<{ flag: FeatureFlagMeta }> {
    return api<{ flag: FeatureFlagMeta }>(
      `/api/admin/feature-flags/${encodeURIComponent(id)}`,
      { auth: true, method: 'PATCH', body: input },
    );
  },

  adminDelete(id: string): Promise<void> {
    return api<void>(`/api/admin/feature-flags/${encodeURIComponent(id)}`, {
      auth: true,
      method: 'DELETE',
    });
  },
};
